import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Home,
  Calendar,
  User,
  ClipboardList,
  ListChecks,
} from "lucide-react";

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { icon: Home, label: "Home", path: "/home" },
    { icon: Calendar, label: "Leave", path: "/leave" },
    { icon: ClipboardList, label: "Tasks", path: "/tasks" },
    { icon: ListChecks, label: "Attendance", path: "/attendance-Report" },
    { icon: User, label: "Profile", path: "/profile" },
  ];

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 w-[95%] max-w-md z-50">
      <div className="bg-white/90 backdrop-blur-xl border border-orange-100 shadow-2xl rounded-3xl px-3 py-2 flex justify-between items-center">

        {navItems.map(({ icon: Icon, label, path }, index) => {
          const isActive = location.pathname === path;

          return (
            <button
              key={index}
              onClick={() => navigate(path)}
              className="flex flex-col items-center justify-center flex-1 transition-all duration-300"
            >
              <div
                className={`flex items-center justify-center w-11 h-11 rounded-2xl transition-all duration-300 ${
                  isActive
                    ? "bg-gradient-to-br from-[#FF7500] to-[#00A650] text-white shadow-lg scale-105"
                    : "text-gray-500 hover:bg-orange-50 hover:text-[#FF7500]"
                }`}
              >
                <Icon size={20} strokeWidth={2.2} />
              </div>

              <span
                className={`mt-1 text-[11px] font-medium transition-all duration-300 ${
                  isActive
                    ? "text-[#00A650]"
                    : "text-gray-500"
                }`}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;